import { VarDefinition } from '@swivl-mono/types';
import { Button, ButtonVariant, Input, Panel } from '@swivl-mono/ui';
import { useState } from 'react';

interface Props {
  variable: VarDefinition;
  updateVar: (v: VarDefinition) => void;
  deleteVar: (v: VarDefinition) => void;
}

export function AdminVariablesEditorVariable(props: Props) {
  const { updateVar } = props;
  const [variable, setVariable] = useState<VarDefinition>(props.variable);
  return (
    <Panel
      className='mb-3'
      header={
        <>
          {variable.type} - {variable.displayName}
        </>
      }
      headerRight={<>{variable.varKey}</>}
    >
      <div>
        <label>Key</label>
        <Input
          value={variable.key}
          onSet={(v) => {
            const updated: VarDefinition = { ...variable, key: v as any };
            setVariable(updated);
            updateVar(updated);
          }}
        />

        <label htmlFor="displayName">Display Name</label>
        <Input
          value={variable.displayName}
          id="displayName"
          name="displayName"
          onSet={(v) => {
            const updated: VarDefinition = { ...variable, displayName: v as any };
            setVariable(updated);
            updateVar(updated);
          }}
        />

        <label htmlFor='description'>Description</label>
        <Input
          value={variable.description}
          name="description"
          id="description"
          onSet={(v) => {
            const updated: VarDefinition = { ...variable, description: v as any };
            setVariable(updated);
            updateVar(updated);
          }}
        />

        <label htmlFor="defaultValue">Default Value</label>
        <Input
          value={variable.defaultValue}
          name="defaultValue"
          id="defaultValue"
          onSet={(v) => {
            const updated: VarDefinition = { ...variable, defaultValue: v as any };
            setVariable(updated);
            updateVar(updated);
          }}
        />

        {/* {variable.type === VarType.Location && (<>
          <label>Default Value</label>
          <RadioButtons 
          value={variable.limitTo} 
            options = {[{label:'Location', value:LimitToLocationType.LOCATION},{label:'Group', value:LimitToLocationType.GROUP},{label:'Org', value:LimitToLocationType.ORG}]}
          inline={true} 
    onOptionSelected={(option:RadioButtonItem) => {
      const updated:VarDefinition = { ...variable, limitTo: option.value as any };
      setVariable(updated);
      updateVar(updated);
    }} />  
        </>)} */}

        <Button variant={ButtonVariant.GHOST} onClick={() => props.deleteVar(variable)}>
          Delete Variable
        </Button>
      </div>
    </Panel>
  );
}
